import React, { useContext,useState } from 'react';
import AdditionalQuestions from '../screens/AdditionalQuestions';
import StepEight from '../screens/StepEight';
import StepFive from '../screens/StepFive';
import StepFour from '../screens/StepFour';
import StepOne from '../screens/StepOne';
import StepSeven from '../screens/StepSeven';
import StepSix from '../screens/StepSix';
import StepThree from '../screens/StepThree';
import StepTwo from '../screens/StepTwo';
import ThankyouScreen from '../screens/ThankyouScreen';
import WelcomeScreen from '../screens/WelcomeScreen';
import { Context } from './Context';

const StartScreen = () => {
    const [context, setContext] = useContext(Context);
    const [isTooltipVisible, setIsTooltipVisible] = useState(null);
    const [clickedTooltip, setClickedTooltip] = useState(null);

    const handleTooltipClick = (tooltipID) => {
        // Toggle the tooltip visibility on click
        if (clickedTooltip === tooltipID) {
          setClickedTooltip(null);
          setIsTooltipVisible(null);
        } else {
          setClickedTooltip(tooltipID);
          setIsTooltipVisible(tooltipID);
        }
      };
      const handleKeyDown = (e, tooltipID) => {
        // e.preventDefault();
        if(e.key ==='Enter' || e.key===' '){
          e.preventDefault()
          if (clickedTooltip === tooltipID) {
            setClickedTooltip(null);
            setIsTooltipVisible(null);
          } else {
            setClickedTooltip(tooltipID);
            setIsTooltipVisible(tooltipID);
          }
          console.log("clicked");
        }
      }
      const handleTooltipMouseEnter = (tooltipID) => {
        // Show tooltip on hover if it hasn't been clicked
        if (clickedTooltip !== tooltipID && clickedTooltip == null) {
          setIsTooltipVisible(tooltipID);
        }
      };
      
      const handleTooltipMouseLeave = (tooltipID) => {
        // Hide tooltip on mouse leave only if it hasn't been clicked
        if (clickedTooltip !== tooltipID && clickedTooltip == null) {
          setIsTooltipVisible(null);
        }
      };

      const tooltipProps = {
        handleTooltipClick,
        handleKeyDown,
        handleTooltipMouseEnter,
        handleTooltipMouseLeave,
        isTooltipVisible
      }

    return (
        <div>
            {context.step === 0 && <WelcomeScreen {...tooltipProps}/> }
            {context.step === 1 && <StepOne {...tooltipProps}/> }
            {context.step === 2 && <StepTwo {...tooltipProps}/> }
            {context.step === 3 && <StepThree {...tooltipProps}/> }
            {context.step === 4 && <StepFour {...tooltipProps}/> }
            {context.step === 5 && <StepFive {...tooltipProps}/> }
            {context.step === 6 && <StepSix {...tooltipProps}/> }
            {context.step === 7 && <StepSeven {...tooltipProps}/> } 
            {context.step === 8 && <StepEight {...tooltipProps}/> } 
            {context.step === 9 && <AdditionalQuestions /> }
            {context.step === 10 && <ThankyouScreen /> }
        </div>
    );
};

export default StartScreen;